import api from './api';
import { Tenant } from '@/types';

export interface TenantWithAdminCreate {
  tenant_name: string;
  tenant_slug: string;
  tenant_address?: string;
  tenant_phone?: string;
  tenant_email?: string;
  admin_email: string;
  admin_full_name: string;
}

export interface TenantWithAdminResponse {
  tenant: Tenant;
  admin_email: string;
  admin_name: string;
  temporary_password: string;
  email_sent: boolean;
}

export interface TenantProfileUpdate {
  name?: string;
  address?: string;
  phone?: string;
  stock_alert_threshold_default?: number;
  expiration_alert_days?: number;
  card_surcharge_percent?: number;
  combos_enabled?: boolean;
  // La tienda tiene dos pasos: habilitada (se configura) y publicada (se ve).
  online_store_enabled?: boolean;
  store_published?: boolean;
  store_whatsapp?: string;
  store_transfer_info?: string;
  store_description?: string;
}

export const tenantsService = {
  async getTenants(): Promise<Tenant[]> {
    const response = await api.get<Tenant[]>('/auth/tenants');
    return response.data;
  },

  async createTenant(data: TenantWithAdminCreate): Promise<TenantWithAdminResponse> {
    const response = await api.post<TenantWithAdminResponse>('/auth/tenants', data);
    return response.data;
  },

  // Perfil del almacén actual
  async getProfile(): Promise<Tenant> {
    const response = await api.get<Tenant>('/tenant/profile');
    return response.data;
  },

  async updateProfile(data: TenantProfileUpdate): Promise<Tenant> {
    const response = await api.put<Tenant>('/tenant/profile', data);
    return response.data;
  },

  async uploadLogo(file: File): Promise<Tenant> {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post<Tenant>('/tenant/profile/logo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async deleteLogo(): Promise<Tenant> {
    const response = await api.delete<Tenant>('/tenant/profile/logo');
    return response.data;
  },
};
